import React from "react";
import styled from "styled-components";
import { FiImage } from "react-icons/fi";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  background: #1a1a1a;
  color: #555;
  text-align: center;
`;

const ImagePlaceholder = ({
  iconSize = 40,
  label = "Nema slike",
  style,
  className,
}) => (
  <Wrapper style={style} className={className}>
    <FiImage size={iconSize} />
    {label && (
      <span style={{ fontSize: "1.2rem", fontFamily: "Poppins-Regular" }}>
        {label}
      </span>
    )}
  </Wrapper>
);

export default ImagePlaceholder;
